{
  "common": {
    "ok": "OK",
    "cancel": "キャンセル",
    "yes": "はい",
    "no": "いいえ",
    "loading": "読み込み中...",
    "error": "エラー",
    "retry": "再試行",
    "apply": "適用",
    "add": "追加"
  },
  "navigation": {
    "home": "ホーム",
    "favorites": "お気に入り",
    "search": "検索"
  },
  "jobs": {
    "noJobs": "仕事が見つかりません",
    "loadMore": "もっと読み込む",
    "apply": "応募する",
    "save": "保存",
    "unsave": "削除"
  },
  "search": {
    "placeholder": "仕事を検索...",
    "filter": "フィルター",
    "clear": "クリア",
    "open": "仕事を検索",
    "close": "検索を閉じる"
  },
  "alerts": {
    "title": "求人アラート",
    "subtitle": "保存した条件に合う新着求人が出たら通知します。",
    "placeholder": "キーワード（例: react リモート シニア）",
    "empty": "アラートはまだありません",
    "matchingNow": "現在 {{count}} 件一致"
  },
  "description": {
    "openUrlMessage": "詳細情報のためにURLを開く",
    "postedOn": "投稿日",
    "applyViewDetails": "応募 / 詳細を見る"
  },
  "error": {
    "title": "問題が発生しました",
    "description": "申し訳ありません、仕事が見つかりません！サーバーまたはネットワークエラーである可能性があります。",
    "tryAgain": "再試行"
  },
  "filter": {
    "refineJobs": "仕事を絞り込む",
    "title": "フィルター",
    "total": "件",
    "reset": "リセット",
    "filterByDate": "日付でフィルター",
    "byDate": "日付別",
    "byApplied": "応募済み別",
    "appliedOnlyOn": "応募済みのみ: ON",
    "appliedOnlyOff": "応募済みのみ: OFF",
    "postedAfter": "次の日付以降に投稿",
    "filterByTags": "タグでフィルター",
    "byTag": "タグ別",
    "clearAllFavorites": "すべての favorites を削除",
    "applyFilters": "フィルターを適用"
  },
  "share": {
    "message": "ここに素晴らしいリモートワークの機会があります：\n* ポジション：{{position}}\n* 会社：{{company}}\n* URL：{{url}}",
    "title": "リモートワークアプリ - {{position}} @{{company}}",
    "subject": "リモートワークアプリから共有された仕事",
    "dialogTitle": "リモートワークの仕事を共有"
  },
  "datepicker": {
    "selectDate": "日付を選択",
    "year": "年",
    "month": "月",
    "previousMonth": "前の月",
    "nextMonth": "次の月",
    "weekdays": [
      "日",
      "月",
      "火",
      "水",
      "木",
      "金",
      "土"
    ],
    "months": [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ]
  },
  "tabs": {
    "allJobs": "すべての仕事",
    "favorites": "お気に入り",
    "resumeBuilder": "履歴書",
    "applications": "応募状況",
    "profile": "プロフィール"
  },
  "favorites": {
    "deleteAll": "すべての favorites を削除",
    "empty": "お気に入りはまだありません。求人のハートをタップしてここに保存しましょう。"
  },
  "icons": {
    "jobActions": "仕事アクション",
    "addToFavorites": "お気に入りに追加",
    "removeFromFavorites": "お気に入りから削除",
    "share": "共有",
    "openUrl": "URLを開く",
    "markApplied": "応募済みにする",
    "removeApplied": "応募済みを取り消す"
  },
  "job": {
    "applied": "応募済み",
    "fit": "マッチ度 {{score}}%"
  },
  "list": {
    "found": "件"
  },
  "onboarding": {
    "tagline": "世界中から厳選されたリモート求人を見つけよう！",
    "next": "次へ"
  },
  "tour": {
    "skip": "スキップ",
    "next": "次へ",
    "getStarted": "はじめる",
    "slides": {
      "welcome": {
        "title": "ようこそ",
        "description": "主な機能をざっと見て、次のリモート求人をより早く見つけましょう。"
      },
      "search": {
        "title": "求人を検索・絞り込み",
        "description": "キーワードで検索し、日付・タグ・応募状況で絞り込めます。"
      },
      "favorites": {
        "title": "お気に入りと応募済み",
        "description": "ハートをタップして求人を保存し、応募済みの求人にマークを付けましょう。"
      },
      "tracker": {
        "title": "応募状況を管理",
        "description": "求人を応募済みにして、面接・内定などの段階をメモや日付とともに追跡できます。"
      },
      "alerts": {
        "title": "新着マッチの通知を受け取る",
        "description": "検索を保存すると、キーワードに合う新しいリモート求人が出たときにプッシュ通知が届きます。"
      },
      "resume": {
        "title": "履歴書を作成",
        "description": "プロフェッショナルな履歴書を作成し、PDF や DOCX で書き出し、各求人が自分のスキルにどれだけ合うか確認できます。"
      },
      "account": {
        "title": "ログインして同期",
        "description": "無料アカウントを作成して、履歴書・応募・お気に入り・アラートをすべての端末にバックアップしましょう。"
      },
      "settings": {
        "title": "テーマと言語",
        "description": "ライト・ダークモードを切り替え、設定から9言語の中から選べます。"
      }
    }
  },
  "theme": {
    "toggle": "テーマを切り替える"
  },
  "settings": {
    "title": "設定",
    "theme": "テーマ",
    "themeLight": "ライト",
    "themeDark": "ダーク",
    "language": "言語",
    "open": "設定を開く",
    "close": "閉じる",
    "developer": "開発者",
    "hideAds": "広告を非表示",
    "removeAds": {
      "title": "広告を削除",
      "buy": "広告を削除 — {{price}}",
      "restore": "購入を復元",
      "purchased": "RemoteWorkをご支援いただきありがとうございます！広告はオフになっています。",
      "successTitle": "広告を削除しました",
      "successMessage": "ご支援ありがとうございます！アプリ全体で広告がオフになりました。",
      "errorTitle": "購入に失敗しました",
      "errorMessage": "問題が発生しました。もう一度お試しください。",
      "restoreEmptyTitle": "復元する項目がありません",
      "restoreEmptyMessage": "このアカウントに以前の購入は見つかりませんでした。"
    },
    "tour": "ツアー",
    "replayTour": "ツアーをもう一度",
    "account": "アカウント",
    "deleteAccount": {
      "action": "アカウントを削除",
      "confirmTitle": "アカウントを削除しますか？",
      "confirmMessage": "アカウントと同期されたすべてのデータ（履歴書・応募・お気に入り・アラート）が完全に削除されます。元に戻せません。",
      "errorTitle": "アカウントを削除できませんでした",
      "errorMessage": "問題が発生しました。もう一度お試しください。",
      "reauthMessage": "安全のため、一度ログアウトして再度ログインしてから、アカウントの削除をお試しください。"
    },
    "about": "アプリについて",
    "privacyPolicy": "プライバシーポリシー",
    "website": "ウェブサイトを見る"
  },
  "ad": {
    "sponsored": "広告"
  },
  "consent": {
    "message": "サイトの利用状況を把握するために分析用 Cookie を使用します。同意いただくまで無効のままです。",
    "accept": "同意する",
    "reject": "拒否する"
  },
  "disclaimer": {
    "title": "求人情報について",
    "message": "このアプリに表示される求人は、第三者の提供元や公開 API から取得したものです。当社はこれらの求人を掲載・選定・管理しておらず、いかなる求人についても正確性・品質・募集状況を保証できません。応募する前に、必ず雇用主に直接詳細をご確認ください。",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "履歴書ビルダー",
    "newResume": "新規作成",
    "newResumePrompt": "履歴書に名前を付けてください",
    "namePlaceholder": "例：フロントエンド履歴書",
    "lastModified": "最終更新",
    "discardTitle": "変更を破棄しますか？",
    "discardMessage": "保存されていない変更があります。",
    "webPlaceholder": {
      "title": "履歴書ビルダーはモバイル専用です",
      "subtitle": "Android または iOS のアプリを開いて、履歴書を作成・エクスポートしてください。"
    },
    "actions": {
      "edit": "編集",
      "duplicate": "複製",
      "delete": "削除",
      "more": "その他",
      "deleteConfirmTitle": "履歴書を削除しますか？",
      "deleteConfirmMessage": "「{{name}}」を完全に削除しますか？この操作は元に戻せません。"
    },
    "empty": {
      "title": "まだ履歴書がありません",
      "subtitle": "プロフェッショナルな履歴書を作成し、PDF または DOCX で書き出しましょう。",
      "cta": "最初の履歴書を作成",
      "skillsHint": "JavaScript、デザイン、リーダーシップなどのスキルを追加…"
    },
    "sections": {
      "personalInfo": "基本情報",
      "experience": "職務経歴",
      "education": "学歴",
      "skills": "スキル",
      "languages": "言語",
      "links": "リンク",
      "template": "テンプレート",
      "contact": "連絡先",
      "summary": "概要",
      "personalization": "パーソナライズ",
      "preview": "プレビュー"
    },
    "fields": {
      "fullName": "氏名",
      "title": "肩書き",
      "email": "メール",
      "phone": "電話番号",
      "location": "所在地",
      "website": "ウェブサイト",
      "summary": "自己紹介",
      "company": "会社",
      "position": "役職",
      "institution": "学校",
      "degree": "学位",
      "field": "専攻",
      "startDate": "開始日",
      "endDate": "終了日",
      "current": "現在もここで働いています",
      "present": "現在",
      "description": "説明",
      "skillPlaceholder": "スキルを追加",
      "languageName": "言語",
      "languageProficiency": "レベル",
      "linkLabel": "ラベル",
      "linkUrl": "URL",
      "phoneCountryCode": "国番号"
    },
    "proficiency": {
      "basic": "基礎",
      "conversational": "日常会話",
      "fluent": "流暢",
      "native": "ネイティブ"
    },
    "templates": {
      "modern": "モダン",
      "classic": "クラシック",
      "minimal": "ミニマル",
      "modernDescription": "色付きサイドバー付きの2カラムレイアウト。",
      "classicDescription": "白黒のシンプルな1カラム伝統的デザイン。",
      "minimalDescription": "余白が多くカラーレスの洗練されたデザイン。"
    },
    "buttons": {
      "addExperience": "職務経歴を追加",
      "addEducation": "学歴を追加",
      "addLanguage": "言語を追加",
      "addLink": "リンクを追加",
      "remove": "削除",
      "save": "保存",
      "discard": "破棄",
      "export": "書き出し",
      "exportPdf": "PDFで書き出し",
      "exportDocx": "DOCXで書き出し",
      "create": "作成",
      "previous": "前へ",
      "next": "次へ"
    },
    "export": {
      "preparing": "ファイルを準備中…",
      "preparingHint": "形式を選択してください。準備ができると共有シートで開きます。",
      "errorTitle": "書き出しに失敗しました",
      "errorMessage": "履歴書の書き出し中に問題が発生しました。"
    },
    "validation": {
      "invalidEmail": "有効なメールアドレスを入力してください。",
      "invalidCountryCode": "+で始まる最大4桁の数字で入力してください。",
      "invalidWebsite": "有効なウェブサイトのアドレスを入力してください（例: example.com）。"
    },
    "personalization": {
      "title": "パーソナライズ",
      "colorMode": "カラーテーマ",
      "modes": {
        "light": "ライト",
        "dark": "ダーク"
      },
      "fontFamily": "フォント",
      "fonts": {
        "sans": "サンセリフ",
        "serif": "セリフ",
        "modern": "モダン",
        "mono": "等幅"
      },
      "fontSize": "フォントサイズ",
      "sizes": {
        "title": "タイトル",
        "subtitle": "サブタイトル",
        "body": "本文"
      },
      "increase": "{{field}}を大きく",
      "decrease": "{{field}}を小さく"
    },
    "photo": {
      "placeholder": "写真なし",
      "choose": "写真を追加",
      "change": "写真を変更",
      "remove": "削除",
      "permissionTitle": "権限が必要です",
      "permissionMessage": "プロフィール写真を選ぶには、写真ライブラリへのアクセスを許可してください。"
    }
  },
  "sort": {
    "recent": "新着順",
    "bestFit": "適合度順",
    "toggle": "適合度で並べ替え"
  },
  "applyKit": {
    "title": "応募キット",
    "hint": "タップしてコピーし、応募フォームに貼り付け。",
    "copied": "コピーしました",
    "openExternal": "ブラウザで開く"
  },
  "applications": {
    "title": "応募状況",
    "empty": {
      "title": "まだ応募がありません",
      "subtitle": "応募した求人がここに表示され、ステータスを管理できます。"
    },
    "status": {
      "applied": "応募済み",
      "interviewing": "面接",
      "offer": "オファー",
      "rejected": "不採用"
    },
    "notesPlaceholder": "メモを追加…",
    "remove": "削除",
    "removeConfirm": "この応募を削除しますか？",
    "lastUpdate": "最終更新: {{date}}",
    "editDate": "日付を編集",
    "addManual": "応募を追加"
  },
  "auth": {
    "account": "アカウント",
    "signIn": "ログイン",
    "signUp": "アカウント作成",
    "signOut": "ログアウト",
    "title": {
      "signIn": "おかえりなさい",
      "signUp": "アカウントを作成"
    },
    "email": "メール",
    "password": "パスワード",
    "showPassword": "パスワードを表示",
    "hidePassword": "パスワードを隠す",
    "forgotPassword": "パスワードをお忘れですか？",
    "resetSent": "パスワード再設定メールを送信しました — 受信トレイをご確認ください。",
    "enterEmailFirst": "先にメールアドレスを入力してください。",
    "noAccount": "アカウントがない場合は作成",
    "haveAccount": "すでにアカウントをお持ちの場合はログイン",
    "criteria": {
      "minLength": "8文字以上",
      "uppercase": "大文字を1つ",
      "lowercase": "小文字を1つ",
      "numeric": "数字を1つ",
      "special": "特殊文字を1つ"
    },
    "errors": {
      "invalid-email": "メールアドレスが正しくないようです。",
      "invalid-credential": "メールまたはパスワードが正しくありません。",
      "user-not-found": "そのメールのアカウントが見つかりません。",
      "wrong-password": "メールまたはパスワードが正しくありません。",
      "email-already-in-use": "そのメールのアカウントは既に存在します。",
      "weak-password": "パスワードが要件を満たしていません。",
      "requires-recent-login": "続行するには再度ログインしてください。",
      "too-many-requests": "試行回数が多すぎます。後でお試しください。",
      "network": "ネットワークエラー。接続を確認してください。",
      "not-configured": "現在ログインは利用できません。",
      "unknown": "問題が発生しました。もう一度お試しください。"
    },
    "continueGoogle": "Googleで続行",
    "continueApple": "Appleで続行",
    "or": "または",
    "loggedInAnonymous": "匿名でログイン中",
    "continueAnonymous": "匿名で続行",
    "loggedOutWarning": "ログインしていません — データはこの端末にのみ保存され、失われる可能性があります。"
  },
  "profile": {
    "title": "プロフィール",
    "signInRegister": "ログイン / 登録",
    "more": "その他"
  },
  "applyBrowser": {
    "title": "応募"
  }
}
